<template>
  <div class='companyDevelopt-container'>
    <header-layout activeIndex="companyDevelopt"></header-layout>
    <div class="companyDevelopment-bg1">
      <img src="../../assets/img/companyDevelopt/gs_02.png" class="bg2-rowImg" width="100%" height="200px"/>
      <img src="../../assets/img/companyDevelopt/gs_04_m.jpg" class="bg2-rowImg" width="100%"/>
      <div class="" id="honour">
        <div style="margin: 10px">
          <el-carousel :interval="10000">
            <el-carousel-item v-for="item in ryList" :key="item">
              <el-image :src="item" fit="cover"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="">
<!--        <el-image :src="w_23"></el-image>-->
      </div>
    </div>
    <el-footer style='padding:0;'>
      <footer-layout></footer-layout>
    </el-footer>

  </div>
</template>

<script>
import HeaderLayout from '@/components/mobile/HeaderLayout.vue';
import FooterLayout from '@/components/mobile/FooterLayout.vue';

export default {
  name: "",
  components: {HeaderLayout, FooterLayout},
  data() {
    return {
      activeIndex: "",
      w_12: require('../../assets/img/home/w_12.jpg'),
      w_23: require('../../assets/img/home/w_23.png'),
      ryList: [
        require('../../assets/img/home/ry1.png'),
        require('../../assets/img/home/ry2.png'),
      ],
    }
  },
  mounted() {

  },
  methods: {}
}
</script>

<style lang='scss' scoped>
.companyDevelopt-container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  background-color: #ffffff;
}

.companyDevelopment-bg1 {
  background-color: #F7F8FB;
  width: 100%;
}
</style>
